export const environment = {
  name: 'dev',
  production: false
};
